import UserService from "../hooks/UserService";
import ApiService from "./ApiService";

const getActiveSubscription = async () => {

        const user = UserService?.data();
        
        try {
            const response = await ApiService.get(`/cms/orders?status=succeeded&author=${user?._id}`);
    
            if (response?.contents) {
                const today = new Date();
                today?.setHours(0, 0, 0, 0); 
    
                const validSubscriptions = response?.contents?.filter(subscription => {    
                    const expiringAt = new Date(subscription?.data?.expiring_at);
                    expiringAt?.setHours(0, 0, 0, 0);     
                    return expiringAt > today; 
                });
                
                const IDList = validSubscriptions?.map(item=>item?.data?.subscription_id?.replace('#',''));
                return IDList;
            } else {
                console.warn("No data received from the subscription API.");
                return [];
            }
        } catch (err) {
            console.error("Error during fetching subscriptions data:", err);
            return [];
        }
};

export default getActiveSubscription